var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['select-picker']},[_c('div',{on:{"click":_vm.openPicker}},[_vm._v(" "+_vm._s(_vm.valueText || _vm.placeholderText)+" "),_c('i',{staticClass:"cubeic-select"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }